import axios from "axios";
import qs from "qs";

import config from "../../config";

const axiosInstance = axios.create({
  baseURL: config.REACT_APP_API_BASE_URL,
  paramsSerializer: function (params) {
    return qs.stringify(params, {
      encodeURIComponent: qs.unescape,
    });
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers = buildHeaders(config);

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.status < 200 || response.status > 204) {
      return parseError(response.data ? response.data.errors : null);
    } else {
      return response;
    }
  },
  (error) => {
    if (error.response.status === 401) {
      let errorMSG = "Session has expired. You will be logged-off.";
      // localStorage.clear();
      clearStorage();
      localStorage.setItem(
        "session-expired",
        "Session has expired. Log-in again."
      );
      window.location.href = "/";
      window.location.reload();
      return Promise.reject({ messages: errorMSG, reload: true });
    }

    if (
      error.response.status === 500 &&
      error?.response?.data?.errors?.message ===
        "Unauthorized. Token not available."
    ) {
      let errorMSG = "Session has expired.  You will be logged-off.";
      // localStorage.clear();
      clearStorage();
      localStorage.setItem(
        "session-expired",
        "Session has expired. Log-in again."
      );
      window.location.href = "/";
      window.location.reload();
      return Promise.reject({ messages: errorMSG, reload: true });
    }

    if (error.response.status === 422) {
      // handling zoho response
      let errMsg = error?.response?.data?.message;
      return Promise.reject({ messages: errMsg, reload: true });
    }

    if (error.response.status === 400) {
      let errMsg = error?.response?.data?.message;
      return Promise.reject({ messages: errMsg, reload: true });
    }

    if (error.response && error.response.data) {
      return parseError(error.response.data.errors);
    }

    return Promise.reject(error);
  }
);

const buildHeaders = (config) => {
  const apiToken = getSessionToken();
  // No security headers are set here on purpose. X-Frame-Options,
  // X-XSS-Protection, Strict-Transport-Security and X-Content-Type-Options are
  // RESPONSE headers: the browser acts on them when a server sends them back.
  // Sending them on an outbound REQUEST has no defined meaning - the backend
  // never reads them, and the browser ignores them. They are set for real by
  // helmet() on the API (project-x-backend src/index.js:132).
  const finalHeaders = {};

  if (apiToken) {
    finalHeaders["Authorization"] = apiToken;
  }

  return finalHeaders;
};

const getSessionToken = () => {
  if (localStorage.getItem("usersession")) {
    const userTenantSession = JSON.parse(localStorage.getItem("usersession"));

    return "Bearer " + userTenantSession.token;
  }

  return null;
};

const parseError = (errors) => {
  let returnErrorMessage = config.generalError;

  if (errors) {
    if (errors instanceof Array) {
      returnErrorMessage = "";
      errors.forEach((error) => {
        returnErrorMessage += error.title + ". ";
      });
    } else {
      returnErrorMessage = errors.message;
    }
  }

  return Promise.reject({
    messages: returnErrorMessage,
  });
};

const clearStorage = () => {
  localStorage.removeItem("usersession");
  localStorage.removeItem("userinfo");
};

const http = axiosInstance;
export default http;
